import VideoCard from '@/components/feature/VideoCard';
import { getFeaturedVideos } from '@/mocks/videos';

export default function FeaturedVideos() {
  const featuredVideos = getFeaturedVideos();

  return (
    <section className="py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
              精选推荐
            </h2>
            <p className="text-foreground-500 text-sm">精心挑选的高品质国产原创视频，为您呈现最优质的内容</p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="lg:col-span-2">
              <VideoCard video={featuredVideos[0]} variant="featured" />
            </div>
            {featuredVideos.slice(1, 5).map((video) => (
              <VideoCard key={video.id} video={video} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}